import { render, staticRenderFns } from "./DashboardCongratulationJohn.vue?vue&type=template&id=1eb68146&scoped=true"
var script = {}
import style0 from "./DashboardCongratulationJohn.vue?vue&type=style&index=0&id=1eb68146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb68146",
  null
  
)

export default component.exports